import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import './user.js';

@Entity()
export class Category extends MongoEntity {
  public static override _class = 'Category';
  public static override _collectionName = 'categories';

  @Field(type => String)
  @validate(nonOptional())
  public name!: string;

  @validate(nonOptional())
  @Field(type => String)
  public institutionID!: string;

  @Field(type => Float)
  sortingWeight?: number;
}
